export default __webpack_public_path__ + "static/media/location.52a1adfd.svg";